'use client';
import { API_CONTACT_US } from '@/constant/apiRout';
import axios from '@/lib/axios';
import { pushToDataLayer } from '@/features/gtm/gtmUtils';
import React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

type FormData = {
  name: string;
  phone: string;
  message: string;
};

const FaqForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors },
  } = useForm<FormData>();

  const onSubmit = async (data: FormData) => {
    try {
      const res = await axios.post(API_CONTACT_US, data);

      if (res.status === 200 || res.status === 201) {
        toast.success(res.data?.message || 'Message sent successfully!');
        pushToDataLayer('generate_lead', { currency: 'BDT' });
        reset();
      } else {
        toast.error(res.data?.message || 'Something went wrong.');
      }
    } catch (error: any) {
      if (error.response) {
        // Server responded with a status outside the 2xx range
        const status = error.response.status;
        const message =
          error.response?.data?.message || 'Failed to send message.';

        if (status === 400) {
          toast.error('Bad Request: ' + message);
        } else if (status === 401) {
          toast.error('Unauthorized: ' + message);
        } else if (status === 500) {
          toast.error('Server Error: ' + message);
        } else {
          toast.error(message);
        }
      } else if (error.request) {
        // Request made but no response received
        toast.error('No response from server. Please try again later.');
      } else {
        // Something else happened
        toast.error('Error: ' + error.message);
      }
    }
  };

  return (
    <div className="contact padding-top padding-bottom">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="contact__form-wrapper">
              <div className="contact__form-title border-bottom">
                <h2>Didn’t find your answer? contact us</h2>
              </div>
              <div className="contact__form">
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  data-aos="fade-left"
                  data-aos-duration={1000}
                >
                  <div className="row g-4">
                    <div className="col-lg-6">
                      <div>
                        <label htmlFor="name" className="form-label">
                          Name
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          id="name"
                          placeholder="Full Name"
                          {...register('name', {
                            required: 'Name is required',
                          })}
                        />
                        {errors.name && (
                          <small className="text-danger d-block mt-1">
                            {errors.name.message}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div>
                        <label htmlFor="phone" className="form-label">
                          Phone
                        </label>
                        <input
                          className="form-control"
                          type="tel"
                          id="phone"
                          placeholder="Phone number"
                          {...register('phone', {
                            required: 'Phone number is required',
                          })}
                        />
                        {errors.phone && (
                          <small className="text-danger d-block mt-1">
                            {errors.phone.message}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="col-12">
                      <div>
                        <label htmlFor="textarea" className="form-label">
                          Message
                        </label>
                        <textarea
                          cols={30}
                          rows={5}
                          className="form-control"
                          id="textarea"
                          placeholder="Enter Your Message"
                          {...register('message', {
                            required: 'Message is required',
                          })}
                        />
                        {errors.message && (
                          <small className="text-danger d-block mt-1">
                            {errors.message.message}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="trk-btn trk-btn--border trk-btn--primary mt-4"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Sending...' : 'Send message'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqForm;
